"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var polished_1 = require("polished");
var PropTypes = __importStar(require("prop-types"));
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("../Themes/styled-components"));
exports.CONTEXT_BAR_HEIGHT = 54;
var ItemWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n"], ["\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n"])));
var Wrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  position: relative;\n  box-sizing: border-box;\n  height: ", ";\n  background-color: ", ";\n  padding: 0 ", ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-top: 1px solid ", ";\n  margin: 0;\n  font-size: ", ";\n  color: ", ";\n  z-index: 1;\n\n  > ", ":not(:last-child) {\n    margin-right: ", ";\n  }\n"], ["\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  position: relative;\n  box-sizing: border-box;\n  height: ", ";\n  background-color: ", ";\n  padding: 0 ", ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-top: 1px solid ", ";\n  margin: 0;\n  font-size: ", ";\n  color: ", ";\n  z-index: 1;\n\n  > ", ":not(:last-child) {\n    margin-right: ", ";\n  }\n"])), polished_1.rem(exports.CONTEXT_BAR_HEIGHT), function (_a) {
    var theme = _a.theme;
    return theme.backgroundColor;
}, function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.grid.gutterWidth);
}, function (_a) {
    var theme = _a.theme;
    return theme.separatorColor;
}, polished_1.rem(14), function (_a) {
    var theme = _a.theme;
    return theme.textColor;
}, ItemWrapper, function (_a) {
    var theme = _a.theme;
    return polished_1.rem(theme.grid.gutterWidth);
});
var Spacer = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  flex: 1 0 0;\n"], ["\n  flex: 1 0 0;\n"])));
exports.ContextBarItem = function (props) {
    return React.createElement(ItemWrapper, null, props.children ? props.children : React.createElement("div", null));
};
exports.ContextBarSpacer = function () {
    return React.createElement(Spacer, null);
};
exports.ContextBar = function (props) {
    return React.createElement(Wrapper, null, props.children);
};
exports.ContextBar.propTypes = {
    children: PropTypes.node,
};
exports.ContextBarItem.propTypes = {
    children: PropTypes.node,
};
exports.ContextBar.defaultProps = {
    children: React.createElement("div", null),
};
exports.ContextBarItem.defaultProps = {
    children: React.createElement("div", null),
};
exports.default = { ContextBar: exports.ContextBar, ContextBarItem: exports.ContextBarItem, ContextBarSpacer: exports.ContextBarSpacer };
var templateObject_1, templateObject_2, templateObject_3;
